import React, { useCallback, useState } from 'react';
import { Box, Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { useActions } from '../../hooks/useActions';

import { ClientSelect } from '../Clients/ClientSelect';
import { teamFormStyle } from './style';

export const AddClientToTeamForm = (props) => {
  const { teamId, closeModal } = props;
  const { t } = useTranslation();

  const { addClientToTeamForm } = teamFormStyle;

  const { linkClientToTeam: addClientToTeam } = useActions();

  const [selectedClient, setSelectedClient] = useState();

  const onChange = (client) => {
    if (!client) {
      setSelectedClient(null);
      return;
    }
    setSelectedClient(client);
  };

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      addClientToTeam(teamId, selectedClient?.value);
      closeModal();
    },
    [addClientToTeam, closeModal, selectedClient, teamId],
  );

  return (
    <Box
      component='form'
      sx={addClientToTeamForm}
      className='create-form validate-form'
      onSubmit={handleSubmit}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <ClientSelect
            fullWidth
            handleChange={onChange}
            selectedId={setSelectedClient?.value}
          />
        </Grid>
        <Grid item xs={12}>
          <div className='container-login100-form-btn'>
            <div className='wrap-login100-form-btn'>
              <div className='login100-form-bgbtn' />
              <button className='login100-form-btn' disabled={!selectedClient}>
                {t('buttons.create.client')}
              </button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
